<template>
  <div>
    <label>{{ column.label }}</label>
    <v-select
      background-color="#fafafa"
      dense
      outlined
      :item-text="column.key"
      :item-value="column.value"
      :items="items"
      v-model="formData[column.prop]"
    ></v-select>
  </div>
</template>

<script>
export default {
  props: {
    formData: Object,
    column: Object,
  },
  data() {
    return {
      controller: this.get_controller(this.column.controller),
    };
  },
  computed: {
    items() {
      return this.controller.list;
    },
  },
};
</script>